export const tz = (
  new Intl.DateTimeFormat('en', { timeZoneName: 'short' })
    .formatToParts(new Date())
    .find(p => p.type === 'timeZoneName')!.value
).replace('GMT', 'UTC');
